<template>
  <div>
    <b-input-group @click="onClick">
      <b-input-group-prepend class="border-right">
        <b-button
          variant="outline-secondary"
          :disabled="disabled"
          style="z-index: unset"
        >
          {{ label }}
        </b-button>
      </b-input-group-prepend>

      <b-form-input readonly class="bg-white text-black-50" :value="arquivos" />
    </b-input-group>

    <input
      :multiple="multiplo"
      :accept="accept"
      :disabled="disabled"
      ref="inputFile"
      name="file-upload"
      type="file"
      class="d-none"
      @change="onInput"
    />
  </div>
</template>

<script>
import { BInputGroup, BInputGroupPrepend, BFormInput } from "bootstrap-vue";

export default {
  name: "HcUploadFile",
  components: {
    BInputGroup,
    BInputGroupPrepend,
    BFormInput
  },
  props: {
    multiplo: {
      type: Boolean,
      default: false
    },
    accept: {
      type: [String, Array],
      default: "*"
    },
    required: {
      type: Boolean,
      default: false
    },
    tamanhoMaximo: {
      type: Number,
      default: 30
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data,
  computed: {
    label,
    arquivos,
    tamanhoMaximoEmMB,
    mimeTypes
  },
  methods: {
    onClick,
    reset,
    onInput,
    _limparInput,
    _emitir,
    _validar,
    _validarTamanhoMaximo,
    _tamanhoExcedidoSingular,
    _tamanhoExcedidoPlural,
    _validarMimeType,
    _mimeTypeInvalidoSingular,
    _mimeTypeInvalidoPlural
  }
};

function data() {
  return {
    value: null
  };
}

function label() {
  return this.multiplo ? "Escolha um ou mais arquivos" : "Escolha um arquivo";
}

function arquivos() {
  if (this.value != null) {
    if (this.multiplo) {
      return this.value.map(file => file.name).join(", ");
    }
    return this.value.name;
  }

  return "";
}

function tamanhoMaximoEmMB() {
  return this.tamanhoMaximo * 1024 * 1024;
}

function mimeTypes() {
  let mimeTypes = this.accept;
  if (mimeTypes.indexOf(",") > -1) {
    mimeTypes = mimeTypes.split(/,/);
  } else {
    mimeTypes = [mimeTypes];
  }
  return mimeTypes.map(string => string.toUpperCase().trim());
}

function onClick() {
  if (this.disabled == false) {
    this.$refs.inputFile.click();
  }
}

function reset() {
  this._limparInput();
  this.value = null;
  this._emitir();
}

function onInput(input) {
  if (input.target.files.length) {
    if (this.multiplo) {
      this.value = Array.from(input.target.files);
    } else {
      this.value = input.target.files[0];
    }
  } else {
    this.value = null;
  }

  this._limparInput();
  this._validar();
  this._emitir();
}

function _limparInput() {
  this.$refs.inputFile.value = "";
}

function _emitir() {
  this.$emit("input", this.value);
  this.$emit("change", this.value);
}

function _validar() {
  this._validarTamanhoMaximo();
  this._validarMimeType();
}

function _validarTamanhoMaximo() {
  if (this.value) {
    let textoNotificacao;
    if (this.multiplo) {
      const tamanhoExcedido = [];
      const tamanhoValido = [];

      this.value.forEach(file => {
        if (file.size > this.tamanhoMaximoEmMB) {
          tamanhoExcedido.push(file);
        } else {
          tamanhoValido.push(file);
        }
      });

      if (tamanhoExcedido.length > 0) {
        textoNotificacao =
          tamanhoExcedido.length === 1
            ? this._tamanhoExcedidoSingular(tamanhoExcedido[0])
            : this._tamanhoExcedidoPlural(tamanhoExcedido);
      }

      this.value = tamanhoValido.length > 0 ? tamanhoValido : null;
    } else {
      if (this.value.size > this.tamanhoMaximoEmMB) {
        textoNotificacao = this._tamanhoExcedidoSingular(this.value);
        this.value = null;
      }
    }

    if (textoNotificacao != null) {
      this.$notify({
            title: this.$t("title.erro"),
            message: textoNotificacao,
            type: "warn"
          });
    }
  }
}

function _tamanhoExcedidoSingular(arquivo) {
  return `
      O arquivo excede o tamanho limite de ${this.tamanhoMaximo}MB.<br />
      ${arquivo.name}
     `;
}

function _tamanhoExcedidoPlural(arquivos) {
  return `
      Os arquivos excedem o tamanho limite de ${this.tamanhoMaximo}MB<br />
      <ul>
        ${arquivos.map(arquivo => `<li>${arquivo.name}</li>`).join("")}
      </ul>
    `;
}

function _validarMimeType() {
  if (this.value) {
    let textoNotificacao;
    if (this.multiplo) {
      const mimeTypeInvalido = [];
      const mimeTypeCorreto = [];

      this.value.forEach(file => {
        if (!this.mimeTypes.includes(file.type.toUpperCase())) {
          mimeTypeInvalido.push(file);
        } else {
          mimeTypeCorreto.push(file);
        }
      });

      if (mimeTypeInvalido.length > 0) {
        textoNotificacao =
          mimeTypeInvalido.length === 1
            ? this._mimeTypeInvalidoSingular(mimeTypeInvalido[0])
            : this._mimeTypeInvalidoPlural(mimeTypeInvalido);
      }

      this.value = mimeTypeCorreto.length > 0 ? mimeTypeCorreto : null;
    } else {
      if (!this.mimeTypes.includes(this.value.type.toUpperCase())) {
        textoNotificacao = this._mimeTypeInvalidoSingular(this.value);
        this.value = null;
      }
    }

    if (textoNotificacao != null) {
      this.$notify({
            title: this.$t("title.erro"),
            message: textoNotificacao,
            type: "warn"
          });
    }
  }
}

function _mimeTypeInvalidoSingular(arquivo) {
  return `
      O arquivo não corresponde a extensão(s) permitida(s).<br />
      ${arquivo.name}
     `;
}

function _mimeTypeInvalidoPlural(arquivos) {
  return `
      Os arquivos não correspondem a extensão(s) permitida(s).<br />
      <ul>
        ${arquivos.map(arquivo => `<li>${arquivo.name}</li>`).join("")}
      </ul>
    `;
}
</script>
